﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1.

export const l = 4000;
export const m = 1000;
export const s = 255;
export const xL = 10000;
export const boardDefaultDuration = 4;
export const fileExtension = 20;
export const userInitials = 50;
export const userLanguage = 10;
export const userPersonnelNumber = 50;
export const agendaItemAdditionalInfo = l;
export const agendaItemDecision = xL;
export const agendaItemDepartment = s;
export const agendaItemFinalBoard = s;
export const agendaItemGuests = xL;
export const agendaItemNote = xL;
export const agendaItemPerusal = xL;
export const agendaItemProtocolEntry = xL;
export const agendaItemProtocolEntryDraft = xL;
export const agendaItemTitle = l;
export const groupEntraIdName = s;
export const groupName = s;
export const boardDefaultLocation = s;
export const boardDefaultRemarks = l;
export const boardDefaultTime = s;
export const boardDescription = l;
export const boardEdecideId = s;
export const boardLongName = s;
export const boardName = s;
export const boardOrganisationUnit = s;
export const boardShortName = s;
export const boardSignatureFirstName = s;
export const boardSignatureLastName = s;
export const fileName = s;
export const meetingAdditionalInfo = l;
export const meetingNote = xL;
export const meetingTitle = s;
export const meetingLocation = s;
export const participantRemarks = m;
export const participantRole = s;
export const storageUrl = l;
export const taskDescription = xL;
export const taskSource = s;
export const uniqueId = m;
export const userEmail = s;
export const userFirstName = s;
export const userLastName = s;
export const userOrganisationUnit = s;
export const userPersonalSiteUrl = m;
export const userPhone = s;
export const userUpn = s;
